// extracted by mini-css-extract-plugin
export default {"about":"about_about__q0up-","aboutLinkPath":"about_aboutLinkPath__ykX0Q","aboutInfo":"about_aboutInfo__AuK3e"};